import { useJumboApp } from '@jumbo/hooks';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { config } from './config/main';
import PropTypes from 'prop-types';



const ProtectedRoutes = ({ component, layout, ...restProps }) => {
    const isAuthenticated = localStorage.getItem('accesstoken');
    const getUserDetails = localStorage.getItem('UserDetails') // Check if the user is authenticated
    const isValidUser = getUserDetails ? JSON.parse(getUserDetails).User_Login_Status : false;
    console.log("isValidUser",isValidUser)
    const { activeLayout, setActiveLayout } = useJumboApp();

    React.useEffect(() => {
        if (layout !== activeLayout) {
            setActiveLayout(layout);
        }
    }, [layout]);


    const PageComponent = component;


    if (isAuthenticated && isValidUser === true) {
        return <PageComponent {...restProps} />;
    } else {
        return <Navigate to="/" />;
    }
}

ProtectedRoutes.propTypes = {
    component: PropTypes.elementType.isRequired,
    layout: PropTypes.string,
};

ProtectedRoutes.defaultProps = {
    layout: config.defaultLayout
};

export default ProtectedRoutes;